import { Observable } from 'rxjs';
import { SearchDto } from '../interfaces/search-dto.interface';
import { SelectorListResponse } from '../interfaces/selector-list-response.interface';
import { SelectorListItem } from '../interfaces/selector-list-item.interface';

export abstract class AbstractSelectorListService<T = SelectorListItem> {
  abstract getItems(dto: SearchDto, currentBuyerId?: string): Observable<SelectorListResponse<T>>;
}
